export default "__VITE_ASSET__BhNq5zh7__"